import React from 'react';

import './CustomerOrderStatuses.scss';

//material ui
import { CircularProgress } from '@material-ui/core';

//custom components
import CustomTable from '../../components/complex/customTable';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';
import DeleteDialog from '../../components/global/deleteDialog';
// import CustomSnackbar from '../../../components/global/snackbar';
// import CustomInput from '../../../components/basic/input';
import ChangeSiblingsPositions from './ChangeSiblingsPositions/ChangeSiblingsPositions';

//api
import {api} from '../../functions/api';

//other libraries
import {toJS} from 'mobx';
import queryString from 'query-string'
import { inject, observer } from 'mobx-react';
import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'
// import EditAddTag from './EditAdd';





@inject('internal')
@inject('translate')
@observer
export default class CustomerOrderStatuses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            searchTerm: "",
            siblingsDialog: false
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.lists_customer_order_statuses)
            && toJS(this.props.internal.user.data.permissions.lists_customer_order_statuses.view)){

            this.loadCustomerOrderStatues();
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);

            const URLqueryString = this.props.history.location.search
            let queries = queryString.parse(URLqueryString);

            let searchterm;
            if(queries) {
                if(queries.searchterm) {
                    searchterm = queries.searchterm
                    this.setState({searchTerm: searchterm})
                }
            }

            this.setPermissions()
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    tableHeader = [
        {
            "title": "name",
            "numeric": false,
            
        },
        {
            "title": "position",
            "numeric": false,
            textAlign: "center"
        },
    ];
    tableBody = [
        "name",
        "id"
    ]

    dropDownMenuItems = []

    setPermissions () {
        this.dropDownMenuItems = []
        let permissions = toJS(this.props.internal.user.data.permissions.lists_customer_order_statuses);
        if(permissions.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    url: "edit"
                },
            )
        }

        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                },
            )
        }
    }

    loadCustomerOrderStatues = async (size = 10, page = 0, searchterm = " ", by = "name", dir = "asc") => {

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let params = {
            searchterm: searchterm,
            page: {
                number: page,
                size: size
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        }


        let load_data = await api({
            method: 'get',
            url: 'lists/customer-order-statuses',
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(load_data.success === true) {
            this.props.internal.setDataForTable(load_data.data)
        }

        this.setState({loading: false})
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else  {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
        // this.addQueryToUrl("by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key && queries[key] !== "") {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadCustomerOrderStatues()
    }

    handleCreateNewStatus = () => {
        this.props.internal.pushRoute('/customer-order-statuses/new')
        // this.props.internal.setRoute(this.props.history, '/customer-order-statuses/new')
    }


    handleDelete = async () => {
        let id = toJS(this.props.internal.actionDeleteObj.id)
        let delete_data = await api({
            method: 'delete',
            url: `lists/customer-order-statuses/${id}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_data.success === true) {
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadCustomerOrderStatues();
            this.props.internal.setActionDelete();
        }
    }

    closeDialogChangePosition = () => {
        this.setState({siblingsDialog: false})
        this.loadCustomerOrderStatues();
    }

    openDialogChangePosition = () => {
        this.setState({siblingsDialog: true})
    }

    render() {
        let permissions = toJS(this.props.internal.user.data.permissions.lists_customer_order_statuses);
        return (
            this.state.loading
                ?
                <CircularProgress className = {'circular-progress'}/>
                :
                <div className={'statusesContainer'}>
                {/* zmena poradia prvkov v menu */}
                    <ChangeSiblingsPositions
                        open={this.state.siblingsDialog}
                        onClose={this.closeDialogChangePosition}
                        title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                        childs={toJS(this.props.internal.dataForTable.data)}
                    />
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.TAGS.DELETE_TAG_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.TAGS.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm }/>
                        {permissions.store ?
                            <CustomButton
                            mystyle={'btn-orange-bg border-radius-18'}
                                title={this.props.translate.i18n.MODULES["CUSTOMER-ORDER-STATUSES"].CREATE_STATUS}
                                onClick={this.handleCreateNewStatus}
                            >
                                <Icon path={mdiPlus} size={1}  />
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    <CustomTable
                        dropDownMenuItems = {this.dropDownMenuItems}
                        module = {'/customer-order-statuses'}
                        handleChangeRowsPerPage = {this.handleChangeRowsPerPage}
                        handleChangePage = {this.handleChangePage}
                        handleSort = {this.handleSort}
                        header = {this.tableHeader}
                        body = {this.tableBody}
                        openDialogSiblings={this.openDialogChangePosition}
                        disablePagination
                    />
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/CustomerOrderStatuses/CustomerOrderStatuses.jsx